"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CircleIcon = ({ ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CircleIconFigure, { ...props,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CircleIconWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CircleIconContentWrapper, {
      children: props.icon
    })
  })
});

CircleIcon.propTypes = {
  icon: _propTypes.default.node.isRequired,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
var _default = CircleIcon;
exports.default = _default;